import { ExceptionsFallback } from '@/routes/single-sign-on/exceptions/fallback'
import { JitFallback } from '@/routes/single-sign-on/jit/fallback'
import { MandatorySsoFallback } from '@/routes/single-sign-on/mandatory-sso/fallback'
import { SsoConfigFallback } from '@/routes/single-sign-on/sso-config/fallback'

export const SingleSignOnFallback = () => {
  return (
    <div className="flex flex-col gap-6 pb-25">
      <SsoConfigFallback />
      <MandatorySsoFallback />
      <ExceptionsFallback />
      <JitFallback />
    </div>
  )
}
